import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useAuth } from '../context/AuthContext';
import './UploadPage.css';

const UploadPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const [formData, setFormData] = useState({
    name: '',
    category: '',
    condition: '',
    description: '',
    price: 0,
    picture: [],
  });
  const [error, setError] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleImageChange = (e) => {
    setFormData(prevState => ({ ...prevState, picture: [...e.target.files] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.picture.length === 0) {
      setError("Por favor, subí al menos una imagen.");
      return;
    }
    setError('');
    setIsUploading(true);
  
    if (!user) {
      setError("Necesitás iniciar sesión para publicar un producto.");
      navigate('/login');
      setIsUploading(false);
      return;
    }
  
    let imageUrls = []; 
    const token = Cookies.get('authToken');
  
    try {
      const imageFormData = new FormData();
      for (const image of formData.picture) {
        imageFormData.append('picture', image);
      }
      
      const imageResponse = await fetch("https://tech-market-ba-back.vercel.app/images/", {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: imageFormData,
      });
  
      if (imageResponse.ok) {
        const imageResult = await imageResponse.json();
        imageUrls = imageResult.urls;
      } else {
        console.error("Fallo en la subida de imágenes, pero se continuará con la creación del producto.");
        const errorBody = await imageResponse.json().catch(() => ({}));
        setError(`Error en imágenes: ${errorBody.message || 'El servidor no respondió.'}. Se intentará crear el producto sin ellas.`);
      }
  
    } catch (err) {
      console.error("Error de conexión al subir imágenes:", err);
      setError("No se pudieron subir las imágenes, se intentará crear el producto sin ellas.");
    }
  
    try {
      const productData = {
        name: formData.name,
        description: formData.description,
        category: formData.category,
        model: "Genérico",
        condition: formData.condition,
        price: parseInt(formData.price, 10),
        id_user: user.id_user,
        picture: imageUrls,
      };
  
      const productResponse = await fetch("https://tech-market-ba-back.vercel.app/products/", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(productData),
      });
  
      if (!productResponse.ok) {
        const errorBody = await productResponse.json().catch(() => ({}));
        throw new Error(errorBody.message || 'Error al crear la publicación del producto.');
      }
  
      const newProduct = await productResponse.json();
      navigate(`/product/${newProduct.id_product}`);
  
    } catch (err) {
      setError(err.message);
      console.error(err);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="upload-page-container">
      <div className="upload-form-box">
        <h2>Subí un producto</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-section">
            <h4>Información del artículo</h4>
            <label htmlFor="category">Categoría</label>
            <select id="category" name="category" value={formData.category} onChange={handleChange} required>
              <option value="" disabled>Seleccione una categoría</option>
              <option value="Procesadores">Procesadores (CPU)</option>
              <option value="Placas de Video">Placas de Video (GPU)</option>
              <option value="Gabinetes">Gabinetes</option>
              <option value="PCs">PCs</option>
              <option value="Laptops">Laptops</option>
              <option value="Otros">Otros</option>
            </select>
            <label htmlFor="name">Nombre del artículo</label>
            <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} maxLength="100" required />
          </div>

          <div className="form-section">
            <h4>Imágenes</h4>
            <input type="file" id="picture" name="picture" onChange={handleImageChange} multiple accept="image/png, image/jpeg, image/webp" required />
          </div>

          <div className="form-section">
            <h4>Descripción</h4>
            <label htmlFor="condition">Condición</label>
            <select id="condition" name="condition" value={formData.condition} onChange={handleChange} required>
              <option value="" disabled>Seleccione una condición</option>
              <option value="Nuevo">Nuevo</option>
              <option value="Usado">Usado</option>
              <option value="Reacondicionado">Reacondicionado</option>
            </select>
            <label htmlFor="description">Descripción del artículo</label>
            <textarea id="description" name="description" value={formData.description} onChange={handleChange} maxLength="6000"></textarea>
          </div>

          <div className="form-section price-stock-section">
            <div>
              <label htmlFor="price">Precio</label>
              <input type="number" id="price" name="price" value={formData.price} onChange={handleChange} min="0" required />
            </div>
          </div>
          
          {error && <p className="error-message">{error}</p>}
          <button type="submit" className="submit-button" disabled={isUploading}>
            {isUploading ? 'Publicando...' : 'Publicar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UploadPage;